class ArticleModel{
    title;
    content;
    date;
    id;
    images;
}

export default ArticleModel